import Vue from 'vue';
import Vuex from 'vuex';
import { getAdminById } from '../api/userFun'
Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        userNameData:'',
    },
    actions:{
        getuserName(context,id){
           return getAdminById({id}).then(res=>{
                context.commit("set_username",res.data.nickname)
            })
              
        },
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            //state.permission=user
            
        },
       set_username(state,name){
        state.userNameData=name;
       },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("Authorization", "");
        }
    },
    getters:{
        permission:state=>{
            return sessionStorage.getItem('permission');
        },
        userName:state=>{
          return  state.userNameData;
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js